
export const validateConfirmPasswordField = (confirmPassword,newPassword) =>{
    let confirmPasswordError='';
      if(confirmPassword===''){
        confirmPasswordError='Confirm Password is required'; // NOSONAR
      }
      if(newPassword!==confirmPassword && confirmPassword){
        confirmPasswordError='Passwords do not match'; // NOSONAR
      }
      return confirmPasswordError;
  }
    
    
    export const validatePasswordField =(value,confirmPassword)=>{
        let commonPasswordError='';
        if (value.trim() === "") {
            commonPasswordError = 'New Password is required'; // NOSONAR
        }else if (value.trim().length < 8) {
            commonPasswordError = `Password must contain at least 8 characters, including uppercase, lowercase, number and special characters.`; // NOSONAR
        }else if(value.search(/[@$!%*?&]/)< 0){
          commonPasswordError="Password must contain at least one special character like @$!%*?&"; // NOSONAR
        }else if(value.search(/[a-z]/) < 0){
            commonPasswordError="Password must contain at least one lowercase letter."; // NOSONAR
        }else if(value.search(/[A-Z]/) < 0){
            commonPasswordError="Password must contain at least one uppercase letter."; // NOSONAR
        }else if(value.search(/[0-9]/)< 0){
          commonPasswordError="Your password must contain at least one digit."; // NOSONAR
        }else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(value)) {
          commonPasswordError="Only special characters like @$!%*?& are permitted"; // NOSONAR
        }else if(value!==confirmPassword && (confirmPassword !== undefined && confirmPassword !== '')){
          commonPasswordError='Passwords do not match'; // NOSONAR
        }
        return commonPasswordError;
      
    }

    
    export const hasPasswordEmpty=(value)=>{
      let validationPasswordError='';
      if (value.trim() === "") {
        validationPasswordError= 'Password is required'; // NOSONAR
       } 
       return validationPasswordError
    }